var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 50 47"}},[_c('path',{attrs:{"fill":"#D8D8D8","fill-rule":"evenodd","d":"M0 0h50v14H0zm0 20h50v27H0z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }